module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [((_vm.mode === 'business' && _vm.mondayDelivery) || (_vm.mode === 'private' && _vm.privateDeliveryDay === 'monday')) ? _c('div', {
    staticClass: "order-result-summary"
  }, [_c('div', {
    staticClass: "order-result-summary__col"
  }, [_c('div', {
    staticClass: "order-result-summary__text-container text-container"
  }, [_c('h4', [_vm._v("Montagslieferung")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.interval('monday').name))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-result-summary__col"
  }, [_c('div', {
    staticClass: "order-result-summary__baskets__list"
  }, _vm._l((_vm.sortedBasketsMonday), function(basket, index) {
    return _c('div', {
      key: ("monday-basket-" + index),
      staticClass: "order-result-summary__weight-container"
    }, [_c('span', {
      staticClass: "order-result-summary__weight-text"
    }, [_vm._v("\n                        " + _vm._s(basket.kg) + " kg\n                    ")])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.wednesdayDelivery) ? _c('div', {
    staticClass: "order-result-summary"
  }, [_c('div', {
    staticClass: "order-result-summary__col"
  }, [_c('div', {
    staticClass: "order-result-summary__text-container text-container"
  }, [_c('h4', [_vm._v("Mittwochslieferung")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.interval('wednesday').name))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-result-summary__col"
  }, [_c('div', {
    staticClass: "order-result-summary__baskets__list"
  }, _vm._l((_vm.sortedBbasketsWednesday), function(basket, index) {
    return _c('div', {
      key: ("wednesday-basket-" + index),
      staticClass: "order-result-summary__weight-container"
    }, [_c('span', {
      staticClass: "order-result-summary__weight-text"
    }, [_vm._v("\n                        " + _vm._s(basket.kg) + " kg\n                    ")])])
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32720657","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/ResultsSummary.vue
// module id = 752
// module chunks = 0